export const AI_CAPABILITIES = [
  'TEXT_TO_IMAGE',
  'IMAGE_TO_IMAGE',
  'TEXT_TO_VIDEO',
  'IMAGE_TO_VIDEO',
  'VIDEO_GENERATION',
  'IMAGE_UNDERSTANDING',
  'VIDEO_UNDERSTANDING',
  'DIGITAL_HUMAN_VIDEO',
  'TEXT_GENERATION',
] as const

export type AiCapability = (typeof AI_CAPABILITIES)[number]

export const AI_TASK_STATUSES = [
  'QUEUED',
  'PREPARING_PROVIDER',
  'SUBMITTING',
  'SUBMIT_UNKNOWN',
  'WAITING_PROVIDER',
  'MATERIALIZING',
  'SUCCEEDED',
  'FAILED',
  'CANCELLED',
] as const

export type AiTaskStatus = (typeof AI_TASK_STATUSES)[number]

export const TERMINAL_AI_TASK_STATUSES: readonly AiTaskStatus[] = [
  'SUCCEEDED',
  'FAILED',
  'CANCELLED',
]

export const AI_INPUT_FIELDS = [
  'prompt',
  'negativePrompt',
  'imageFileIds',
  'firstFrameImageFileId',
  'lastFrameImageFileId',
  'videoFileIds',
  'audioFileIds',
  'outputImageCount',
  'strength',
  'durationSeconds',
  'aspectRatio',
  'resolution',
  'quality',
  'size',
  'outputFormat',
  'seed',
  'generateAudio',
  'speechText',
  'avatarTemplateId',
  'voiceId',
  'speechRate',
  'systemPrompt',
  'userPrompt',
  'temperature',
  'maxOutputTokens',
] as const

export type AiInputField = (typeof AI_INPUT_FIELDS)[number]

export const AI_PARAMETER_TYPES = [
  'string',
  'integer',
  'number',
  'boolean',
  'array',
] as const

export type AiParameterType = (typeof AI_PARAMETER_TYPES)[number]

export const AI_ARTIFACT_MEDIA_TYPES = ['IMAGE', 'VIDEO', 'AUDIO', 'OTHER'] as const

export type AiArtifactMediaType = (typeof AI_ARTIFACT_MEDIA_TYPES)[number]

export const aiCapabilityLabels: Record<AiCapability, string> = {
  TEXT_TO_IMAGE: '文生图',
  IMAGE_TO_IMAGE: '图生图',
  TEXT_TO_VIDEO: '文生视频',
  IMAGE_TO_VIDEO: '图生视频',
  VIDEO_GENERATION: '多模态视频生成',
  IMAGE_UNDERSTANDING: '图片理解',
  VIDEO_UNDERSTANDING: '视频理解',
  DIGITAL_HUMAN_VIDEO: '数字人视频',
  TEXT_GENERATION: '文本生成',
}

export const aiTaskStatusLabels: Record<AiTaskStatus, string> = {
  QUEUED: '排队中',
  PREPARING_PROVIDER: '提交素材库',
  SUBMITTING: '提交中',
  SUBMIT_UNKNOWN: '提交状态未知',
  WAITING_PROVIDER: '等待供应商',
  MATERIALIZING: '成果入库中',
  SUCCEEDED: '已完成',
  FAILED: '失败',
  CANCELLED: '已取消',
}

export const aiArtifactMediaTypeLabels: Record<AiArtifactMediaType, string> = {
  IMAGE: '图片',
  VIDEO: '视频',
  AUDIO: '音频',
  OTHER: '其他',
}

export function getAiCapabilityLabel(value: AiCapability | string) {
  return aiCapabilityLabels[value as AiCapability] ?? value
}

export function getAiTaskStatusLabel(value: AiTaskStatus | string) {
  return aiTaskStatusLabels[value as AiTaskStatus] ?? value
}

export function getAiArtifactMediaTypeLabel(value: AiArtifactMediaType | string) {
  return aiArtifactMediaTypeLabels[value as AiArtifactMediaType] ?? value
}
